import { Door } from "../../data/models.interface"
import useQuery from "../useQuery"

export const useGetDoorsQuery = () => {
	const url = `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/doors`
	return useQuery<void, DoorsOutput>(url)
}
interface DoorsOutput {
	doors: Door[]
}
